import { supabase } from './supabase';
import { userService } from '../services/userService';
import { resolveChAccess } from '../contenthub/lib/chAccess';

export interface ModuleAccess {
  mainApp: boolean;
  contentHub: boolean;
  /** Has their own creator account (influencer_auth). */
  creatorsHubOwn: boolean;
  /** Agency staff (admin/agent) — may open any creator's portal in view mode. */
  isStaff: boolean;
}

export async function resolveModuleAccess(): Promise<ModuleAccess> {
  const [userRole, chAccess, userRes] = await Promise.all([
    userService.getCurrentUserRole(),
    resolveChAccess(),
    supabase.auth.getUser(),
  ]);

  const uid = userRes.data.user?.id;
  let creatorsHubOwn = false;
  if (uid) {
    const { data } = await supabase
      .from('influencer_auth')
      .select('id')
      .eq('auth_user_id', uid)
      .eq('status', 'active')
      .maybeSingle();
    creatorsHubOwn = !!data;
  }

  const isStaff = !!userRole && (userRole.role === 'admin' || userRole.role === 'agent');
  return {
    mainApp: isStaff,
    // Clients have Content Hub access too (they only see their projects)
    contentHub: chAccess.hasAccess,
    creatorsHubOwn,
    isStaff,
  };
}
